// third-party
import { FormattedMessage } from 'react-intl';
import { SHOW_SUPERUSER_PREFERENCES } from 'config';

// assets
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
// type

// icons
const icons = { SettingsOutlinedIcon };

// ==============================|| MENU ITEMS - DOCTOR ||============================== //

const doctor = {
  id: 'doctor',
  title: <FormattedMessage id="Doctor" />,
  icon: icons.SettingsOutlinedIcon,
  type: 'group',
  children: [
    {
      id: 'super_user_preferences',
      key: 'super_user_preferences',
      title: <FormattedMessage id="Preferences" />,
      type: 'item',
      url: '/admin/super-user-preferences',
      icon: icons.SettingsOutlinedIcon,
      visible: () => SHOW_SUPERUSER_PREFERENCES
    },
  ]
};

export default doctor;

